import { React } from 'react';
import { useTranslation } from 'react-i18next';

// Placeholder shell — no data source/API has been defined for this grid yet.
const Payable = ({ tableLoading }) => {
    const { t } = useTranslation();
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <table className="table">
                    <thead>
                        <tr>
                            <th>{t('unitMaster.payableFields.value')}</th>
                            <th>{t('unitMaster.unitFeaturesFields.description')}</th>
                            <th>{t('unitMaster.payableFields.landlord')}</th>
                            <th>{t('unitMaster.payableFields.tenant')}</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </div>
    );
};
export default Payable;
